import { SensorConnectionStatus, SensorSkuId } from 'app/modules/inventory/bins/core/enum';
import { StatusItem } from 'app/modules/inventory/items/core/constants';

export const SENSOR_STATUS_STYLES = {
  [SensorConnectionStatus.online]: {
    icon: 'var(--success)',
    background: 'var(--success-light-1-5)',
  },
  [SensorConnectionStatus.offline]: {
    icon: 'var(--danger)',
    background: 'var(--danger-light-1-5)',
  },
  [SensorConnectionStatus.notReady]: {
    icon: 'var(--neutral-7)',
    background: 'var(--neutral-3)',
  },
};

export const SENSOR_STATUS_TEXT = {
  [SensorConnectionStatus.online]: 'Operational',
  [SensorConnectionStatus.offline]: 'No heartbeat',
  [SensorConnectionStatus.notReady]: 'Unassigned',
};

export const DISPLAY_SENSOR_SKU_ID = (skuId: SensorSkuId) =>
  ({
    [SensorSkuId.Weight]: 'Weight',
    [SensorSkuId.CV]: 'Computer Vision',
    [SensorSkuId.Expiry]: 'Expiry Sensor',
    [SensorSkuId.Hanger]: 'Hanger',
  }[skuId] || 'Computer Vision expired');

export const DEFAULT_ITEM_FILTER = {
  statuses: [],
};

export const ITEM_STATUS_OPTIONS = [
  { value: StatusItem.Active, label: 'Active' },
  { value: StatusItem.Inactive, label: 'Inactive' },
];
